import type { HTMLAttributes, PropsWithChildren } from 'react'
import { RecipientDisplayName } from './RecipientDisplayName';
import { RecipientBankAccount } from './RecipientBankAccount';
import { RecipientCountry } from './RecipientCountry';
import { cn } from '../../utils/cn';
import { Icon } from '../Icon';

type RecipientCardProps = PropsWithChildren & HTMLAttributes<HTMLDivElement>;

export const RecipientCard = ( { children, className, ...divAttrs }: RecipientCardProps ) => {

  const Components = Array.isArray( children ) ? children : [ children ];
  const DisplayName = Components.find( c => c?.type?.displayName === RecipientDisplayName.displayName );
  const BankAccount = Components.find( c => c?.type?.displayName === RecipientBankAccount.displayName );
  const Country = Components.find( c => c?.type?.displayName === RecipientCountry.displayName );

  return (
    <div
      className={ cn( 'relative border border-[#FFFFFF1A] bg-[#0C102E80] p-4 rounded-[10px] max-w-[380px] w-full flex flex-col gap-2.5 shadow-[0px_-4px_8px_0px_rgba(255,255,255,0.10)_inset]', className ) }
      { ...divAttrs }>
      <div className={ 'flex flex-col gap-2.5' }>
        <div className={ 'flex flex-row justify-between items-center gap-5' }>
          { DisplayName }
        </div>
        { BankAccount }
      </div>
      {( Country ) && (
        <div className={ 'flex flex-row justify-between gap-5 items-center' }>
          {Country}
        </div>
      )}
      <div className={ 'absolute right-0 inset-y-0 flex items-center justify-center pr-1.5' }>
        <Icon name={ 'chevron-right' } />
      </div>
    </div>
  )
}
RecipientCard.displayName = 'RecipientCard';
